<h2 mat-dialog-title>Confirmar</h2>
<div mat-dialog-content>
    <p [innerHTML]="mensaje"></p>
</div>
<div mat-dialog-actions style="text-align: right;">
    <button mat-button class="btn btn-secondary" (click)="closeDialog()">Cancelar</button> &nbsp;&nbsp;
    <button mat-button class="btn btn-primary" (click)="confirm()" cdkFocusInitial>Aceptar</button>
</div>